import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ reflection, onConfirm, onCancel }) => {
  const hasVideo = reflection.video_key || reflection.video_url;
  const hasAudio = reflection.audio_key || reflection.audio_url;
  const hasText = reflection.text_content;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="delete-confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Delete Reflection?</h2>

        <p className="delete-warning">
          This action cannot be undone. The following will be permanently deleted:
        </p>

        <ul className="delete-items-list">
          {hasVideo && <li>📹 Video recording</li>}
          {hasAudio && <li>🎤 Audio recording</li>}
          {hasText && <li>📝 Text content</li>}
          <li>📊 All reflection metadata</li>
        </ul>

        <div className="modal-actions">
          <button
            className="btn-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn-delete"
            onClick={onConfirm}
          >
            🗑️ Delete Reflection
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
